import Rest from '@/services/Rest';

export default class CommentService extends Rest {
  static resource = 'comment';
}
